import {Component, computed, inject, input} from '@angular/core';
import {CountryCode} from '@frontend/directus';
import {CountryService} from '@frontend/shared';

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  imports: [],
})
export class CountryListComponent {
  readonly countries = input<CountryCode[]>([]);
  readonly heading = input<string | null>(null);

  private readonly countryService = inject(CountryService);

  readonly hasCountries = computed<boolean>(() => this.countries().length > 0);

  getCountryDisplayName(country: CountryCode): string {
    return this.countryService.getCountryDisplayName(country);
  }

  getCountryFlagUrl(countryCode: string): string {
    return this.countryService.getCountryFlagUrl(countryCode);
  }
}
